import { CreateNotificationProps, Notification } from 'modules/core/domain/interfaces/supabase/notifications/types';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { AppDispatch } from 'store/store';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { createNotification } from '../../store/actions';
import NotificationForm from '../components/notification-form';

const CreateNotificationPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const isAdmin = useIsAdmin();
  const { setHeaderContent } = useMainLayout();

  const handleSubmit = useCallback(
    async (values: Partial<Notification>) => {
      try {
        await dispatch(createNotification(values as CreateNotificationProps)).unwrap();
        navigate(Pages.NOTIFICATIONS.INDEX);
        toast.success('Уведомление создано');
      } catch (error) {
        console.error('Error creating notification:', error);
        toast.error('Ошибка создания уведомления');
      }
    },
    [dispatch, navigate],
  );

  const handleCancel = useCallback(() => {
    navigate(Pages.NOTIFICATIONS.INDEX);
  }, [navigate]);

  const breadcrumbs = useMemo(() => {
    return [
      { label: 'Уведомления', to: Pages.NOTIFICATIONS.INDEX },
      { label: 'Создание уведомления', to: Pages.NOTIFICATIONS.CREATE },
    ];
  }, []);

  useEffect(() => {
    setHeaderContent(<UDBreadcrumbs breadcrumbs={breadcrumbs} />);
    return () => setHeaderContent(null);
  }, [breadcrumbs, setHeaderContent]);

  if (!isAdmin) {
    return <Navigate to={Pages.NOTIFICATIONS.INDEX} replace />;
  }

  return (
    <>
      <div className="w-full px-6 p-6" style={{ margin: '0 auto' }}>
        <NotificationForm onSubmit={handleSubmit} onCancel={handleCancel} />
      </div>
    </>
  );
};

export default CreateNotificationPage;
